/**
 * The keyboard focus ring of the consent screens and the shared dialogs (`Dialog`, `ConfirmDialog`), moved here
 * from `consent/` with `useModal` (Apple design review X-8): a solid amber outline with an offset, as PRODUCT.md asks
 * of every interactive element (`--accent-amber` with offset). The browser's own ring is dark on the
 * warm-dark surface and is not reliably seen there.
 *
 * It is `--accent-amber`, not `--accent-amber-emphasis` (the 0.55 amber that `OfferControls.tsx` uses).
 * Measured in a browser at 1440 wide, as the contrast of the ring against the ground just outside it, on
 * the Privacy rows: the 0.55 ring came out at 1.7 to 3.7:1 on the light panel the rows first had and at
 * 1.9 to 3.7:1 on the dark one they have now, under the 3:1 that WCAG 2.2 asks of a focus indicator at
 * several of its sides, and the solid ring at 4.4 to 8.9:1 at the sides of the pills and the link on the
 * dark one (the top edge of the link read 2.8 to 3.1, where the sample straddles the rule 4 px above it).
 * `consentGrounds.test.ts` grades it against the recess at the page gradient's tan peak.
 */
export const FOCUS_RING =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--accent-amber)'

/** The same ring drawn inside the element, for one a parent clips (a scrolling region in a dialog's panel). */
export const FOCUS_RING_INSET =
  'focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-(--accent-amber)'
